module.exports = __webpack_public_path__ + "img/Reed Ingram.57d17cd2.jpg";